(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("rxjs/Subject"), require("@angular/common"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "rxjs/Subject", "@angular/common"], factory);
	else if(typeof exports === 'object')
		exports["ngScrollTo"] = factory(require("@angular/core"), require("rxjs/Subject"), require("@angular/common"));
	else
		root["ngScrollTo"] = factory(root["ng"]["core"], root["Rx"], root["ng"]["common"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition